import pickBy from 'lodash/pickBy';
import {getIn, FormikErrors} from 'formik';

export const hasErrors = <T>(errors: FormikErrors<T>, path: string) =>
    !!Object.keys(pickBy(getIn(errors, path))).length;
